import { render, staticRenderFns } from "./ReservatableFrame.vue?vue&type=template&id=d65c251a&scoped=true&"
import script from "./ReservatableFrame.vue?vue&type=script&lang=js&"
export * from "./ReservatableFrame.vue?vue&type=script&lang=js&"
import style0 from "./ReservatableFrame.vue?vue&type=style&index=0&id=d65c251a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65c251a",
  null
  
)

export default component.exports